import { Link } from "react-router-dom";
import { VERTICALS } from "@/lib/content";
import { Icon } from "@/components/common/Icon";
import { usePathSelector } from "@/context/PathSelectorContext";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const MEGA_MENU_MOTION = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: { duration: 0.2 },
};

// Services mega-menu — three vertical columns.
export const MegaMenu = ({ onNavigate }) => {
  const { openSelector } = usePathSelector();
  return (
    <motion.div
      {...MEGA_MENU_MOTION}
      className="grid w-[min(60rem,90vw)] grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border shadow-2xl shadow-slate-900/10 md:grid-cols-3"
      data-testid="services-mega-menu"
    >
      {VERTICALS.map((v) => (
        <div key={v.id} className="bg-white p-6">
          <Link
            to={`/services#${v.id}`}
            onClick={onNavigate}
            className="group flex items-center justify-between"
            data-testid={`mega-vertical-${v.id}`}
          >
            <span className="font-heading text-lg font-bold text-slate-900">{v.name}</span>
            <ArrowUpRight className="h-4 w-4 text-slate-400 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:text-blue-600" />
          </Link>
          <p className="mt-1 text-xs text-slate-500">{v.tagline}</p>
          <ul className="mt-4 space-y-1">
            {v.services.map((s) => (
              <li key={s.name}>
                <Link
                  to={`/services/${s.slug}`}
                  onClick={onNavigate}
                  data-testid={`mega-service-${s.slug}`}
                  className="flex items-center gap-2.5 rounded-lg px-2 py-1.5 text-sm text-slate-600 transition-colors duration-200 hover:bg-blue-50 hover:text-blue-700"
                >
                  <Icon name={s.icon} className="h-4 w-4 text-blue-600" />
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="col-span-full flex items-center justify-between bg-slate-950 px-6 py-4">
        <span className="text-sm text-slate-300">Not sure which fits? Start from your problem.</span>
        <button
          onClick={() => {
            openSelector();
            onNavigate?.();
          }}
          data-testid="mega-tell-us"
          className="rounded-full bg-blue-600 px-5 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-blue-500"
        >
          Tell Us What You Need
        </button>
      </div>
    </motion.div>
  );
};
